import { useEditor, useNode } from "@craftjs/core";
import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Edit } from "@/components/icons/edit";
import { Switch } from "@/components/shared/switch";

export default function VideoWithParagraphSettings() {
  const { childNodes, linkedNodes, showCTA, actions } = useNode((node) => ({
    children: node.data.props?.children,
    nodeId: node.id,
    childNodes: node.getChildNodes(),
    linkedNodes: node.getLinkedNodes().map((node) => node.node),
    showCTA: node.data.props?.showCTA ?? false,
  }));
  const nodes = [...linkedNodes, ...childNodes];
  const { t } = useTranslation();
  const {
    actions: { selectNode },
  } = useEditor();

  const handleSwitchToggle = useCallback(
    (checked: boolean) =>
      actions.setProp((props) => {
        props.showCTA = checked;
      }),
    [actions]
  );

  return (
    <div className="flex flex-col gap-y-4 p-4">
      <div className="mt-2 flex items-center justify-between">
        <span className="flex items-center justify-start gap-x-2">
          <span className="text-sm">{t("content-hub.show-cta")}</span>
        </span>
        <Switch
          label={t("content-hub.show-cta")}
          defaultChecked={showCTA}
          onChange={handleSwitchToggle}
        />
      </div>
      <div className="flex items-center justify-between border-b border-solid border-gray-200 pb-2">
        <span className="text-sm font-medium">Nodes</span>
      </div>
      <div className="flex flex-col gap-y-2">
        {nodes?.map((child) => (
          <div
            key={child.id}
            className="flex w-full items-center justify-between gap-x-2 border-b border-solid border-gray-200 p-2 text-sm"
          >
            {child.data.displayName}
            <button
              onClick={() => {
                selectNode(child.id);
              }}
            >
              <Edit className="size-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
